import React from 'react'
import { hourglass } from 'ldrs';

// Register all loaders
hourglass.register();


function ThemedSuspense() {
  return (
    <div className="w-full h-screen flex items-center justify-center text-lg font-medium text-gray-600 dark:text-gray-400 dark:bg-gray-900">
      <div className="flex flex-col items-center space-y-4">
        <l-hourglass size="45" color="#00A76F" speed="2"></l-hourglass>
        <div className="flex items-center space-x-2">
          <span className="animate-pulse">Loading</span>
          <span className="animate-bounce delay-100">.</span>
          <span className="animate-bounce delay-200">.</span>
          <span className="animate-bounce delay-300">.</span>
        </div>
      </div>
    </div>
  )
}

export default ThemedSuspense
